import { useState, useEffect } from 'react'
import { copyToClipboard, generateSummary, getTranscriptionAsText , getUserAccessToken, addBulletListTags, addNewlineTags, addColourToNames, trackEvent, highlightText, checkIfStandardSummaryIsEligible } from '../../utils/genericUtils'
import { SummaryNotFound } from '../edgeCaseStates/SummaryNotFound'
import { IconWithTimeoutReplaceOnClick } from '../../utils/IconWithTimeoutReplaceOnClick'
import { ButtonWithTimeoutReplaceOnClick } from '../../utils/ButtonWithTimeoutReplaceOnClick'

const SummarySection = ({ custom_bullet_summary_label, header, text, setShowZoomTranscriptInfoPopup, setShowMsTeamsTranscriptInfoPopup, isBackend, getSpeakerColourByName, searchWords }) => {
  const isError = text.error

  var formattedText;

  if(header === 'Call summary') {
    formattedText = text
  }
  if(header === 'Bullet summary') {
    if(custom_bullet_summary_label?.trim()?.length) {
      header = custom_bullet_summary_label
    }
    formattedText = addBulletListTags(text)
  }
  if(header === 'Key insights') {
    formattedText = addNewlineTags(addBulletListTags(text), "^Discussion Topic:")
  }
  if(header === 'Action items') {
    formattedText = addColourToNames(addBulletListTags(text), getSpeakerColourByName)
  }

  return <>
    <div className="summary-section">
      <div>
        <h4>{header}</h4>
        {text && !isError ? <div style={{ width: 14, height: 14 }}>
          <IconWithTimeoutReplaceOnClick onClick={() => copyToClipboard(text)} 
            initialIcon={<svg width="14" height="14" viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M11.719 12.7191V3.81277H4.7488V12.7191H11.719ZM11.719 2.5617C12.0566 2.5617 12.3545 2.69078 12.6126 2.94894C12.8708 3.18723 12.9999 3.47518 12.9999 3.81277V12.7191C12.9999 13.0567 12.8708 13.3546 12.6126 13.6128C12.3545 13.8709 12.0566 14 11.719 14H4.7488C4.41121 14 4.11334 13.8709 3.85518 13.6128C3.59703 13.3546 3.46795 13.0567 3.46795 12.7191V3.81277C3.46795 3.47518 3.59703 3.18723 3.85518 2.94894C4.11334 2.69078 4.41121 2.5617 4.7488 2.5617H11.719ZM9.81263 0V1.28085H2.1871V10.1872H0.936035V1.28085C0.936035 0.943262 1.05518 0.64539 1.29348 0.387234C1.55164 0.129078 1.84951 0 2.1871 0H9.81263Z" fill="#E44867"/>
            </svg>} 
            clickedIcon={<svg width="14" height="14" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill="#E44867" d="M6.38498 12.0188L13.5962 4.80751L12.4695 3.64319L6.38498 9.7277L3.53052 6.87324L2.40376 8L6.38498 12.0188ZM2.32864 2.3662C3.9061 0.788732 5.79656 0 8 0C10.2034 0 12.0814 0.788732 13.6338 2.3662C15.2113 3.91862 16 5.79656 16 8C16 10.2034 15.2113 12.0939 13.6338 13.6714C12.0814 15.2238 10.2034 16 8 16C5.79656 16 3.9061 15.2238 2.32864 13.6714C0.776213 12.0939 0 10.2034 0 8C0 5.79656 0.776213 3.91862 2.32864 2.3662Z"/>
            </svg>
          }/>
          </div>  : <span></span>}
        
      </div>
      {header === 'Action items' && isBackend ? <div className="black">
        Action items not looking good? Make sure you upload the transcript with participants names: <a onClick={() => {

          trackEvent("briefly-how-to-get-zoom-transcripts-click", {
              source: 'SUMMARY_TAB'
          })

          setShowZoomTranscriptInfoPopup(true)

        }}>How to get transcripts for Zoom</a>, <a onClick={() => { 

          trackEvent("briefly-how-to-get-ms-teams-transcripts-click", {
              source: 'SUMMARY_TAB'
          })

          setShowMsTeamsTranscriptInfoPopup(true)} 

        }>How to get transcripts for MS Teams</a>
      </div> : ''}
      <p>
        {isError ? 'OpenAI error. Please try again later...' : searchWords ? highlightText(text, searchWords, {background: '#F9C338', color: 'black'}) : text ? <div dangerouslySetInnerHTML={{__html: formattedText}}></div> : 'Please ensure that you have uploaded the transcript in the correct format as action items are displayed for each meeting participant.'}
      </p>
    </div>
  </>
}

const SUMMARY_COLUMNS_CONFIG = [
  [
    {
      label: 'Call summary',
      key: 'short_summary'
    },
    {
      label: 'Bullet summary',
      key: 'long_summary'
    }
  ],
  [
    {
      label: 'Key insights',
      key: 'key_insights'
    }
  ],
  [
    {
      label: 'Action items',
      key: 'action_items'
    }
  ]
]

export default function MeetingTabSummary({ userData, aiSummaryCostsAiCredit, meetingSummaryWasRequestedBefore, meetingData, setShowZoomTranscriptInfoPopup, setShowMsTeamsTranscriptInfoPopup, setShowOutOfCreditsPopup, searchWords }) {

  const { meetingId, isBackend } = meetingData

  const [meetingSummary, setMeetingSummary] = useState(null)

  const [isGenerating, setIsGenerating] = useState(false)

  const LOCASTORAGE_SUMMARY_KEY = 'summary-cache-' + meetingId

  const MAX_STORED_SUMMARIES = 1000

  const { custom_bullet_summary_label } = userData

  const isStorageOverloaded = () => {
    var count = 0
    for(const key in localStorage) {
      if(key.includes('summary-cache-')) {
        count ++
      }
    }
    console.log('storage count', count)
    return count >= MAX_STORED_SUMMARIES
  }

  const removeOldestSummary = () => {
    var oldestTimestamp = null
    var oldestEntryKey = null
    for(const key in localStorage) {
      if(key.includes('summary-cache-')) {
        var { timestamp } = JSON.parse(localStorage.getItem(key))
        if(!timestamp) {
          oldestEntryKey = key;
          break;
        }
        if(!oldestTimestamp || timestamp.localeCompare(oldestTimestamp) < 0) {
          oldestTimestamp = timestamp;
          oldestEntryKey = key
        }
      }
    }
    console.log('removing', JSON.parse(localStorage.getItem(oldestEntryKey)))
    localStorage.removeItem(oldestEntryKey)
  }

  const getMeetingSummary = async () => {
    setMeetingSummary(null)

    if(localStorage.getItem(LOCASTORAGE_SUMMARY_KEY)) {
      setMeetingSummary( JSON.parse( localStorage.getItem(LOCASTORAGE_SUMMARY_KEY) ) )
      return
    } 

    console.log('loading cached summary')
    const meetingSummaryData = await new Promise(resolve => {

      const handler = e => {
        if(e.detail.getCachedSummaryById) {
          window.removeEventListener("background-message-response", handler)
          resolve({
            meetingSummary: e.detail.getCachedSummaryById
          })
        }
      }

      window.addEventListener("background-message-response", handler)

      window.dispatchEvent(new CustomEvent('background-message', { detail: { getCachedSummaryById: meetingId}}));
    })

    console.log('loaded cached summary')

    setMeetingSummary(meetingSummaryData.meetingSummary)
  }

  useEffect(() => {
    getMeetingSummary()
  }, [])

  useEffect(() => {
    getMeetingSummary()
  }, [meetingId])


  function handleGenerateSummary() {

    checkIfStandardSummaryIsEligible(getTranscriptionAsText(meetingData), isEligible => {
      if(isEligible) {
        setIsGenerating(true)

        getUserAccessToken(({ access }) => {


          trackEvent("briefly-create-generate-ai-summary", {
            meetingSource: meetingData.isBackend ? 'UPLOAD' : 'BRIEFLY_EXTENSION'
          })

          generateSummary(
              getTranscriptionAsText(meetingData), access, summaryData => {
                setIsGenerating(false)
                setMeetingSummary(summaryData)

                if(isStorageOverloaded()) {
                  removeOldestSummary()
                }

                localStorage.setItem(LOCASTORAGE_SUMMARY_KEY, JSON.stringify({
                  ...summaryData,
                  timestamp: new Date()
                }))
              }
          )


        })
      } else {
        setShowOutOfCreditsPopup(true)
      }
    })

    

  }

  if(!meetingSummary || isGenerating) {
    return <div className="generate-ai-summary" style={{ display: 'flex', justifyContent: 'center', marginTop: 60 }}>
      
      <div style={{ width: 400, textAlign: 'center' }}>
        <svg width="146" height="98" viewBox="0 0 146 98" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M24.7437 10.4934H120.594C122.954 10.4934 124.868 12.4067 124.868 14.7669V93.2983C124.868 95.6585 122.954 97.5718 120.594 97.5718H24.7437C22.3835 97.5718 20.4702 95.6585 20.4702 93.2983V14.7669C20.4702 12.4067 22.3835 10.4934 24.7437 10.4934Z" fill="#141414"/>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M30.9502 19.293H124.81V97.1184H30.9502V19.293Z" fill="#2C2C2C"/>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M121.078 10.4556H24.2618C22.2643 10.4556 20.6469 12.1192 20.6469 14.1681V19.2756H124.693V14.1717C124.693 12.1192 123.074 10.4556 121.078 10.4556Z" fill="#E44867"/>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M24.7437 10.4934H120.594C122.954 10.4934 124.868 12.4067 124.868 14.7669V93.2983C124.868 95.6585 122.954 97.5718 120.594 97.5718H24.7437C22.3835 97.5718 20.4702 95.6585 20.4702 93.2983V14.7669C20.4702 12.4067 22.3835 10.4934 24.7437 10.4934Z" stroke="#C6C6C6" stroke-width="0.42" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M24.2156 24.0984H27.157" stroke="#C6C6C6" stroke-width="0.42" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M24.2156 30.0818H27.157" stroke="#C6C6C6" stroke-width="0.42" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M24.2156 36.0669H27.157" stroke="#C6C6C6" stroke-width="0.42" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M24.2156 42.052H27.157" stroke="#C6C6C6" stroke-width="0.42" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M24.2156 48.0369H27.157" stroke="#C6C6C6" stroke-width="0.42" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M24.2156 54.022H27.157" stroke="#C6C6C6" stroke-width="0.42" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M25.1071 14.6565H44.3315" stroke="white" stroke-width="0.630001" stroke-linecap="round" stroke-linejoin="round"/>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M135.431 28.6717C139.65 30.9579 140.306 33.9816 140.39 35.2013L140.396 35.2915C140.396 35.306 140.397 35.3201 140.398 35.3339L140.4 35.413L140.401 35.4843L140.401 35.5476L140.4 35.6269L140.397 35.6868L140.392 35.7459C140.454 40.5574 139.482 41.7621 138.944 42.061L138.903 42.0822C138.89 42.0887 138.877 42.0947 138.864 42.1001L138.828 42.1151C138.816 42.1196 138.804 42.1236 138.793 42.1272L138.761 42.1369L138.731 42.1444L138.704 42.1499L138.68 42.1538L138.658 42.1563L138.632 42.158L138.612 42.1582L138.598 42.1574C136.442 41.9149 135.541 39.7564 135.171 38.2337L135.138 38.0928L135.108 37.9562L135.081 37.8243C135.072 37.7811 135.064 37.7388 135.056 37.6974L135.034 37.5762C135.031 37.5565 135.028 37.537 135.024 37.5178L135.006 37.4058L134.99 37.3006L134.976 37.2027L134.959 37.0703L134.946 36.9568L134.933 36.8376L134.924 36.7218L135.431 28.6717ZM125.143 28.0731C126.687 30.6672 127.093 33.5123 127.178 35.3L127.186 35.4697L127.191 35.6325L127.195 35.7881L127.197 35.9364C127.197 35.9605 127.198 35.9842 127.198 36.0077L127.198 36.1444L127.197 36.273L127.194 36.4503L127.19 36.608L127.184 36.7451L127.176 36.8947L127.167 37.0249L127.161 37.0941C127.235 41.4046 125.488 42.007 124.681 42.0561L124.62 42.0588C124.61 42.0591 124.6 42.0593 124.591 42.0595L124.536 42.0595L124.486 42.0581L124.441 42.0556L124.4 42.0524L124.35 42.0469L124.304 42.0401L124.282 42.036C123.127 41.8416 122.596 40.4142 122.353 39.0886L122.327 38.9362L122.302 38.7852C122.299 38.7601 122.295 38.7352 122.291 38.7103L122.27 38.5621L122.251 38.4165C122.248 38.3924 122.246 38.3685 122.243 38.3447L122.227 38.2037C122.225 38.1804 122.222 38.1574 122.22 38.1345L122.207 37.999L122.196 37.8679L122.186 37.7416L122.178 37.6205L122.168 37.4497L122.16 37.2932L122.155 37.1526L122.152 37.0294L122.15 36.8948L122.15 36.7284C122.206 31.6926 123.818 29.3701 124.653 28.5029L124.719 28.4357C124.74 28.4144 124.761 28.3941 124.781 28.3748L124.839 28.3199L124.893 28.271L124.943 28.2279L125.008 28.1737L125.045 28.1444L125.102 28.1013L125.143 28.0731ZM114.472 28.7488L114.901 36.8251L114.896 36.8773L114.884 36.9943L114.872 37.0933L114.857 37.2119L114.837 37.3485L114.821 37.4488C114.818 37.4661 114.815 37.4837 114.812 37.5015L114.792 37.6118C114.789 37.6308 114.785 37.6499 114.782 37.6693L114.759 37.7886L114.733 37.9133C114.724 37.9557 114.714 37.9989 114.704 38.0428L114.673 38.1768C114.31 39.6733 113.399 41.8864 111.171 41.959L111.152 41.9583L111.12 41.9547L111.099 41.951C111.095 41.9503 111.092 41.9495 111.088 41.9486L111.062 41.9424C111.057 41.9412 111.053 41.9399 111.048 41.9385L111.018 41.9291L110.985 41.9172C110.979 41.9149 110.973 41.9126 110.968 41.9101L110.931 41.8939C110.925 41.8909 110.918 41.8878 110.912 41.8845L110.872 41.8632C110.354 41.571 109.351 40.3882 109.433 35.6068L109.437 35.415L109.433 35.3569L109.431 35.2969L109.43 35.2461L109.43 35.187L109.431 35.1198L109.434 35.0449L109.438 34.9625L109.444 34.8728C109.448 34.8263 109.453 34.7771 109.458 34.7255L109.471 34.6191C109.643 33.286 110.498 30.5712 114.472 28.7488Z" fill="#F97238"/>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M124.346 0.775453C124.346 0.775453 111.52 7.08199 115.015 37.4173L134.581 37.5043C134.581 37.5043 138.377 10.8397 127.354 0.868944C127.354 0.868944 126.111 -0.216863 124.346 0.775453Z" fill="#434343" stroke="#C6C6C6" stroke-width="0.376143" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M124.469 0.638901L124.469 0.639144L124.478 0.634033C125.329 0.137863 126.04 0.165844 126.534 0.30953C126.784 0.38212 126.981 0.485278 127.115 0.570145C127.182 0.612523 127.233 0.649987 127.266 0.676161C127.278 0.685817 127.288 0.693758 127.294 0.699658L127.311 0.715654C130.91 4.11244 132.948 9.36175 134.053 14.936L115.967 14.9779C117.358 9.295 119.476 5.71547 121.248 3.55518C122.146 2.46004 122.956 1.72852 123.54 1.27206C123.831 1.04381 124.066 0.884283 124.227 0.782439C124.307 0.731517 124.369 0.695014 124.41 0.67155C124.431 0.659818 124.446 0.651347 124.456 0.645963L124.467 0.640181L124.469 0.638986L124.469 0.638901Z" fill="#E44867" stroke="#C6C6C6" stroke-width="0.375962"/>
          <ellipse cx="124.762" cy="20.9417" rx="2.92938" ry="3.03435" transform="rotate(-45.5 124.762 20.9417)" fill="#C6C6C6"/>
          <path d="M128.12 3.70459C128.12 3.70459 129.234 4.91833 130.123 7.09322" stroke="white" stroke-width="0.564215" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M59.4377 61.4982H90.5507" stroke="#C6C6C6" stroke-width="0.42" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M42.05 68.3974H107.939" stroke="#C6C6C6" stroke-width="0.42" stroke-linecap="round" stroke-linejoin="round"/>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M57.6168 75.2068H92.3716C93.9176 75.2068 95.1709 76.4601 95.1709 78.0061V84.8927C95.1709 86.4388 93.9176 87.692 92.3716 87.692H57.6168C56.0708 87.692 54.8175 86.4388 54.8175 84.8927V78.0061C54.8175 76.4601 56.0708 75.2068 57.6168 75.2068Z" fill="#E44867"/>
          <path d="M67.6276 81.5963H82.3849" stroke="white" stroke-width="0.630001" stroke-linecap="round" stroke-linejoin="round"/>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M5.38959 26.4658L1.11426 50.5284H45.6121L48.9515 26.4658H5.38959V26.4658Z" fill="#2C2C2C"/>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M5.38959 26.4658L1.11426 50.5284H45.6121L48.9515 26.4658H5.38959V26.4658Z" stroke="#C6C6C6" stroke-width="0.31871" stroke-linecap="round" stroke-linejoin="round"/>
          <circle cx="15.7788" cy="38.6161" r="1.49526" fill="#EC8E00"/>
          <circle cx="24.5897" cy="38.6161" r="1.49526" fill="#EC8E00"/>
          <circle cx="33.362" cy="38.6161" r="1.49526" fill="#EC8E00"/>
        </svg>

        <h5>{ isGenerating ? 'Generating AI summary...' : 'Your AI Summary is ready to be generated!' } </h5>

        {!isGenerating && <button style={{ height: 40, width: 260 }} onClick={() => handleGenerateSummary()}>{meetingSummaryWasRequestedBefore ? 'View' : 'Generate'} AI summary {aiSummaryCostsAiCredit ? '[1 AI Credit]' : ''}</button>}

        {isGenerating && <div className="loader-container">
          <div className="loader-inner"/>
        </div>}
      </div>

    </div>
  }

  const anyError = meetingSummary && SUMMARY_COLUMNS_CONFIG.find(items => items.find(x => meetingSummary[x.key].error))


  return (
    <div id="summary-outer-container">
      <div id="summary-container" className={anyError && 'is-error'}>
        {meetingSummary ? <div>
          {anyError ? <div className="summary-error">
            There was an issue with OpenAI while generating some AI summaries, try again later
            <br/>
            <a onClick={() => handleGenerateSummary()}>Try again</a>
          </div> : ''}

          <ButtonWithTimeoutReplaceOnClick

            initialText={
              <>
                <svg width="13" height="15" viewBox="0 0 13 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M11.2512 13.2191V4.31277H4.28103V13.2191H11.2512ZM11.2512 3.0617C11.5888 3.0617 11.8867 3.19078 12.1449 3.44894C12.403 3.68723 12.5321 3.97518 12.5321 4.31277V13.2191C12.5321 13.5567 12.403 13.8546 12.1449 14.1128C11.8867 14.3709 11.5888 14.5 11.2512 14.5H4.28103C3.94344 14.5 3.64557 14.3709 3.38741 14.1128C3.12925 13.8546 3.00018 13.5567 3.00018 13.2191V4.31277C3.00018 3.97518 3.12925 3.68723 3.38741 3.44894C3.64557 3.19078 3.94344 3.0617 4.28103 3.0617H11.2512ZM9.34486 0.5V1.78085H1.71933V10.6872H0.468262V1.78085C0.468262 1.44326 0.587411 1.14539 0.825709 0.887234C1.08386 0.629078 1.38174 0.5 1.71933 0.5H9.34486Z" fill="white"/>
                </svg>
                Copy entire AI summary
              </>
            }

            clickedText={
              <>
                <svg width="14" height="14" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill="white" d="M6.38498 12.0188L13.5962 4.80751L12.4695 3.64319L6.38498 9.7277L3.53052 6.87324L2.40376 8L6.38498 12.0188ZM2.32864 2.3662C3.9061 0.788732 5.79656 0 8 0C10.2034 0 12.0814 0.788732 13.6338 2.3662C15.2113 3.91862 16 5.79656 16 8C16 10.2034 15.2113 12.0939 13.6338 13.6714C12.0814 15.2238 10.2034 16 8 16C5.79656 16 3.9061 15.2238 2.32864 13.6714C0.776213 12.0939 0 10.2034 0 8C0 5.79656 0.776213 3.91862 2.32864 2.3662Z"/>
                </svg>
                Copied to clipboard
              </>
            }

            onClick={() => {
              var concat = ''
              SUMMARY_COLUMNS_CONFIG.map(items => items.map(({ label, key }) => {
                concat += label + ':\n'
                concat += meetingSummary[key] + '\n\n'
              }))
              copyToClipboard(concat)
            }}

          />
          <div className="summary-columns">
            {SUMMARY_COLUMNS_CONFIG.map(items => <div className="summary-column">
              {items.map(({ label, key }) => {
                return <SummarySection 
                  custom_bullet_summary_label={custom_bullet_summary_label}
                  header={label} text={meetingSummary[key]} 
                  setShowZoomTranscriptInfoPopup={setShowZoomTranscriptInfoPopup} 
                  setShowMsTeamsTranscriptInfoPopup={setShowMsTeamsTranscriptInfoPopup}
                  isBackend={isBackend}
                  getSpeakerColourByName={isBackend ? null : speakerName => {
                    var speakerId = null
                    for(var id in meetingData.deviceNamesById) {
                      if(meetingData.deviceNamesById[id] === speakerName) {
                        speakerId = id;
                        break;
                      }
                    }

                    if(speakerId) {
                      return meetingData.deviceColorsById[speakerId]
                    } else {
                      return 'white'
                    }
                  }}
                  searchWords={searchWords}
                  />

              })}
            </div>)}
          </div>
        </div> : ''}
      </div>
    </div>
  );
}
